import { useParams } from 'react-router-dom';
import { useClientAuth } from '../context/ClientAuthContext';
import { BuyerPortalPanels, useBuyerPortalData } from '../components/clientPortal/BuyerPortalPanels';
import './ClientPortal.css';

export default function ClientBuyingPage() {
  const { slug } = useParams();
  const { client, reload } = useClientAuth();
  const buyerData = useBuyerPortalData(slug, client, reload);

  return (
    <div className="client-portal-page">
      <header className="client-portal-page__header">
        <h1>Buying your next home</h1>
        <p>Everything synced from your conversations with {client.agent?.assistant_name || 'Ava'}.</p>
      </header>
      <BuyerPortalPanels client={client} slug={slug} buyerData={buyerData} />
    </div>
  );
}
